import { FormControl, OutlinedInput, Theme } from "@mui/material";
import FormHelperText, {
  FormHelperTextProps
} from "@mui/material/FormHelperText";
import InputLabel, { InputLabelProps } from "@mui/material/InputLabel";
import { OutlinedInputProps } from "@mui/material/OutlinedInput";
import makeStyles from "@mui/styles/makeStyles";
import { forwardRef } from "react";

const useStyles = makeStyles((theme: Theme) => ({
  formControl: { marginTop: theme.spacing(1) },
  notchedOutline: {
    borderColor: theme.palette.primary.main,
    "& legend": {
      width: 90.5
    }
  },
  label: { color: theme.palette.primary.main }
}));

interface FormInputType extends OutlinedInputProps {
  displayName?: string;
  errorMessage?: string;
  inputLabelProps?: InputLabelProps;
  formHelperTextProps?: FormHelperTextProps;
}

const FormInput = forwardRef<HTMLInputElement, FormInputType>(
  (
    {
      name,
      errorMessage,
      displayName,
      inputLabelProps,
      formHelperTextProps,
      ...rest
    },
    ref
  ) => {
    const { formControl, notchedOutline, label } = useStyles({});
    return (
      <FormControl
        error={Boolean(errorMessage)}
        variant="outlined"
        className={formControl}
      >
        <InputLabel
          htmlFor="component-error"
          {...inputLabelProps}
          shrink
          classes={{ root: label }}
        >
          {displayName || name}
        </InputLabel>
        <OutlinedInput
          name={name}
          notched
          {...rest}
          ref={ref}
          classes={{ notchedOutline }}
        />
        <FormHelperText id="component-error-text" {...formHelperTextProps}>
          {errorMessage}
        </FormHelperText>
      </FormControl>
    );
  }
);

export default FormInput;
